type RenderCodeProps = {
    code: string[];
    isGameStarted: boolean;
    isGameFinished: boolean;
};

const RenderCode: React.FC<RenderCodeProps> = ({
  code,
  isGameStarted,
  isGameFinished,
}) => {
  return (
    <div
      className="tableS-board-game-code--Type1"
      style={{
        gridTemplateColumns: `repeat(${code.length}, 5vw)`,
      }}
    >
      {isGameStarted &&
        !isGameFinished &&
        code.map((cell, index) => (
          <div
            key={index}
            className="tableS-board-game-code-cell--Type1"
          >
            {cell}
          </div>
        ))}
    </div>
  );
};

export default RenderCode;